import SideNav from "../shared/sideNav";
import "font-awesome/css/font-awesome.min.css";
import "../assets/stylesheet/layout.scss";
import React, { useState, useEffect } from "react";
import "../assets/stylesheet/dashboard.scss";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import DateRangePickerComponent from "../components/date-range";
import DonutChart from "../components/donutChart";
import CombinedChart from "../components/stackedBarWithLineChart";
import { EngagementTrends } from "../components/engagementComponent";
import { CustomerExperienceSearch } from "../components/customerExprience";
import { ResponseThrough, ResponseType } from "../components/journeyMatrics";
import ApiRequest from "../services/apiService";
import StackedPercentageBarChart from "../components/stackedPercentageBarChart";
import { ShowToastUtil } from "../utilities/showToastUtil";
import DashboardHeader from "../shared/dashboardHeader";
import ScreenLoader from "../components/screenLoader";
import getUserDetails from "../utilities/getUserDetails";
import baseUrl from "../services/baseUrl";
import MyMultiSelectDropdown from "../utilities/multiSelectInputType";
import SingleSelectTouchpointDropdown from "./Dashboard/DropDownSelectTouchpointInputType";
import SingleSelectSobDropDown from "./Dashboard/DropDownSelectSobInputType";
import { tree } from "d3";
import { useNavigate } from "react-router-dom";

//author-saksham
function Dashboard() {
  const [projects, setProjects] = useState([]);
  const [detractors, setDetractors] = useState(0);
  const [passives, setPassives] = useState(0);
  const [promotors, setPromotors] = useState(0);
  const [totalNps, setTotalNps] = useState(0);
  const [responseRate, setResponseRate] = useState(0);
  const [promotorsPercentage, setPromotorsPercentage] = useState(0);
  const [passivesPercentage, setPassivesPercentage] = useState(0);
  const [detractorsPercentage, setDetractorsPercentage] = useState(0);
  const [projectWiseNps, setProjectWiseNps] = useState([]);
  const [npsTrendsChart, setNpsTrendsChart] = useState([]);
  const [engagementTrends, setEngagementTrends] = useState([]);
  const [isOverAllNpsChartView, setIsOverAllNpsChartView] = useState(true);
  const [isOverAllNpsGridView, setIsOverAllNpsGridView] = useState(false);
  const [journeyMetrics, setJourneyMetrics] = useState({});
  const [sobChartData, setSobChartData] = useState([]);
  const [isNpsTrendsChartView, setIsNpsTrendsChartView] = useState(true);
  const [isNpsTrendsBarView, setIsNpsTrendsBarView] = useState(false);
  const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
  const [IsLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || '');
  const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
  const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
  const [isAllTouchPoints, setIsAllTouchpoints] = useState(
    (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints'))?true:false
  );
  const [noDataScreen, setNoDataScreen] = useState(false);
  const [userData, setUserData] = useState(getUserDetails() || {});
  const navigate = useNavigate();

  const GetDashboardData = async (
  ) => {
    setIsLoading(true);
    setNoDataScreen(false);
    try {
      const params = new URLSearchParams({
        quickFilterRange: quickFilter,
        fromDate: localStorage.getItem("fromDate") || fromDate,
        toDate: localStorage.getItem("toDate") || toDate,
        projectFilter: localStorage.getItem("projectFilter") || projectFilter,
        touchpointFilter: touchpointFilter,
        userRole: userData.UserRole,
        userProject: userData.ProjectIds,
        userCode: userData.UserCode,
        sobFilter: sobFilter,
      });
      const url = `${baseUrl()}/nps/GetNpsDashboardChartsData?${params.toString()}`;
      const responseData = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (responseData.Data && responseData.IsSuccess) {
        setIsLoading(false);
        const data = responseData.Data;
        setProjects(data.Projects || []);
        setDetractors(data.OverallNpsChart.Detractors || 0);
        setPassives(data.OverallNpsChart.Passives || 0);
        setPromotors(data.OverallNpsChart.Promotors || 0);
        setTotalNps(data.OverallNpsChart.Nps || 0);
        setResponseRate(data.OverallNpsChart.ResponseRate || 0);
        setProjectWiseNps(data.NpsProjectCharts || []);
        setNpsTrendsChart(data.NpsTrendsCharts || []);
        setEngagementTrends(data.EngagementTrendsCharts || []);
        setJourneyMetrics(data.JourneyResponse || {});
        setSobChartData(data.SobChartData || []);
      } else {
        setNoDataScreen(true);
        ShowToastUtil("No data available for selected range", "warning");
        return;
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      navigate("/login");
      sessionStorage.clear();
      localStorage.clear();
      window.location.reload();
      setTimeout(ShowToastUtil("Please try login again", "error"), 1000);
    } 
    // finally {
    //   setIsLoading(false);
    // }
  };
  useEffect(() => {
    GetDashboardData();
  }, [
    quickFilter,
    fromDate,
    toDate,
    projectFilter,
    touchpointFilter,
    sobFilter,
  ]);

  useEffect(() => {
    const total = promotors + passives + detractors;
    if (total > 0) {
      setPromotorsPercentage(((promotors / total) * 100).toFixed(2));
      setPassivesPercentage(((passives / total) * 100).toFixed(2));
      setDetractorsPercentage(((detractors / total) * 100).toFixed(2));
    } else {
      setPromotorsPercentage(0);
      setPassivesPercentage(0);
      setDetractorsPercentage(0);
    }
  }, [promotors, passives, detractors]);

  const donutData = {
    labels: ["Promoters", "Passives", "Detractors"],
    datasets: [
      {
        label: "",
        data: [promotors, passives, detractors],
        backgroundColor: ["#008000", "#ffb62f", "#f10000"],
        borderColor: ["#008000", "#ffb62f", "#f10000"],
        borderWidth: 0,
        hoverOffset: 0,
      },
    ],
  };

  let delayed;

  const donutOptions = {
    responsive: true,
    animation: {
      onComplete: () => {
        delayed = true;
      },
      delay: (context) => {
        let delay = 0;
        if (context.type === "data" && context.mode === "default" && !delayed) {
          delay = context.dataIndex * 300 + context.datasetIndex * 100;
        }
        return delay;
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        display: false,
      },
      datalabels: {
        formatter: (value, ctx) => {
          const total = ctx.chart.data.datasets[0].data.reduce(
            (acc, val) => acc + val,
            0
          );
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage>0?percentage+'%':''}`;
        },
        color: "#fff",
      },
      anchor: "end",
      align: "end",
    },
  };

  const handleOverAllNpsChartView = () => {
    setIsOverAllNpsGridView(false);
    setIsOverAllNpsChartView(true);
  };

  const handleOverAllNpsGridView = () => {
    setIsOverAllNpsChartView(false);
    setIsOverAllNpsGridView(true);
  };

  const handleNpsTrendsBarView = () => {
    setIsNpsTrendsBarView(true);
    setIsNpsTrendsChartView(false);
  };

  const handleNpsTrendsChartView = () => {
    setIsNpsTrendsBarView(false);
    setIsNpsTrendsChartView(true);
  };

  const checkProjectIdsForNftrandftr = () => {
    const userDetails = getUserDetails();
      if (userDetails || userDetails.ProjectIds) {
      const ProjectIdsArray = userDetails.ProjectIds.split(",").map(Number); 
      return ProjectIdsArray.includes(10) || ProjectIdsArray.includes(11) || userDetails.UserRole == 'CCare';
    }
    return false;
  };
  const checkProjectIdsForLabUsers = () => {
    const userDetails = getUserDetails();
     if (userDetails || userDetails.ProjectIds) {
      const ProjectIdsArray = userDetails.ProjectIds.split(",").map(Number);
      return ProjectIdsArray.includes(1) || userDetails.UserRole == 'Lab';
    }
    return false;
  };
  
  const handleDateRangeFilter = (startDate, endDate) => {
    if (startDate && endDate) {
      setFromDate(startDate.toISOString().split("T")[0]);
      setToDate(endDate.toISOString().split("T")[0]);
      setQuickFilter("");
    } else {
      setFromDate("");
      setToDate("");
    }
    localStorage.setItem('quickFilter', '');
      localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
      localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
  };

  const handleQuickFilter = async (event) => {
    const selectedValue = event.target.value;
    setFromDate('');
    setToDate('');
    setQuickFilter(selectedValue);
    localStorage.setItem('fromDate', '');
    localStorage.setItem('toDate', '');
    localStorage.setItem('quickFilter', selectedValue);
    window.location.reload();
  };

  useEffect(()=>{
    if(!localStorage.getItem('quickFilter') && !localStorage.getItem('fromDate')){
      setQuickFilter('FTD');
      localStorage.setItem('quickFilter', 'FTD');
    }
  }, []);
  
  useEffect(() => {
    if (checkProjectIdsForNftrandftr()) {
      if(projectFilter == ''){
        setProjectFilter('4');
        localStorage.setItem('projectFilter', '4');
      }
    }
  }, []);
  useEffect(()=>{
    if (checkProjectIdsForLabUsers()) {
      if(projectFilter == ''){
        setProjectFilter('1');
        localStorage.setItem('projectFilter', '1');
      }
    }
  }, []);

  const handleTouchpointFilter = (touchpoint) => {
    setTouchpointFilter(touchpoint);
    localStorage.setItem("touchpointFilter", touchpoint);
  }

  const handleSobFilter = (selectedSob) => {
    setSobFilter(selectedSob);
    localStorage.setItem("sobFilter", selectedSob);
  }

  const handleAllTouchpointSelect = (isSelected) => {
    setSobFilter('');
    setIsAllTouchpoints(isSelected);
  }

  const handleProjectFilter = (event) => {
    const selectedOption = event.target.value;
    setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
    localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
    localStorage.removeItem("sobFilter");
    localStorage.removeItem("touchpointFilter");
    window.location.reload();
  };

  return (
    <div>
      <DashboardHeader />
      <div className="main-container">
        <SideNav />
        <section className="container-fluid">
          <>
            {/* top filter area */}
            <div className="row mb-2">
              <div className="col-12">
                <div className="card">
                  <div className="card-body p-2 pt-2 d-flex align-items-center">
                    <div
                      className={
                        IsLoading
                          ? "d-none did-floating-label-content mb-0"
                          : "did-floating-label-content mb-0"
                      }
                    >
                      <div className="did-floating-label-content me-0 mb-0">
                        <select
                          className="did-floating-select w-150px h-300"
                          value={projectFilter}
                          onChange={handleProjectFilter}
                        >
                          <option value="">Select All Project</option>
                          {projects.map((project) => (
                            <option
                              key={project.ProjectId}
                              value={project.ProjectId}
                            >
                              {project.ProjectName}
                            </option>
                          ))}
                        </select>
                        <label className="did-floating-label">
                          Project Filter
                        </label>
                      </div>
                    </div>
                    <div
                      className={
                        IsLoading
                          ? "d-none did-floating-label-content mb-0 ms-2"
                          : "did-floating-label-content mb-0 ms-2"
                      }
                    >
                      <SingleSelectSobDropDown
                        onSobSelect={handleSobFilter}
                        onAllTouchpointSelect={handleAllTouchpointSelect}
                      />
                    </div>
                    <div
                      className={
                        !isAllTouchPoints || IsLoading
                          ? "d-none did-floating-label-content mb-0 ms-2"
                          : "did-floating-label-content mb-0 ms-2"
                      }
                    >
                      <SingleSelectTouchpointDropdown
                        onTouchPointSelect={handleTouchpointFilter}
                      />
                    </div>
                    <div
                      className={
                        IsLoading ? "d-none ms-auto d-flex" : "ms-auto d-flex"
                      }
                    >
                      <div className="did-floating-label-content mb-0 me-3">
                        <select
                          className="did-floating-select w-100px h-30"
                          value={quickFilter}
                          onChange={handleQuickFilter}
                        >
                          <option value={""}>Select Filter</option>
                          <option>FTD</option>
                          <option>WTD</option>
                          <option>MTD</option>
                          <option>QTD</option>
                          <option>YTD</option>
                        </select>
                        <label className="did-floating-label">
                          Quick Filter
                        </label>
                      </div>
                      <div
                        className={
                          IsLoading
                            ? "d-none did-floating-label-content mb-0 h-30"
                            : "did-floating-label-content mb-0 h-30"
                        }
                      >
                        {
                          <DateRangePickerComponent
                            onRangeSelect={handleDateRangeFilter}
                            quickFilter={quickFilter}
                          />
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* dashboard chart area */}
            {IsLoading ? (
              <div className="screenLoader">
                <ScreenLoader />
              </div>
            ) : noDataScreen ? (
              <h5 className="loadingScreen text-center">No data available</h5>
            ) : (
              <div className="row g-2">
                {/* Overall NPS */}
                <div
                  className={
                    projectFilter.split(",").includes("1") ||
                    projectFilter.split(",").includes("4") ||
                    projectFilter.split(",").includes("5")
                      ? "col-12 col-md-6 col-lg-4"
                      : "col-14 col-md-8 col-lg-6"
                  }
                >
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="card-title d-flex align-items-center">
                        <h3>Overall NPS</h3>
                        <div className="card-option ms-auto">
                          <ButtonGroup className="view-type" size="sm">
                            <Button
                              onClick={handleOverAllNpsChartView}
                              variant="outline-secondary"
                              className={
                                isOverAllNpsChartView
                                  ? "active px-2 py-1"
                                  : "px-2 py-1"
                              }
                            >
                              <i
                                className="fa fa-pie-chart"
                                aria-hidden="true"
                              ></i>
                            </Button>
                            <Button
                              onClick={handleOverAllNpsGridView}
                              variant="outline-secondary"
                              className={
                                isOverAllNpsGridView
                                  ? "active px-2 py-1"
                                  : "px-2 py-1"
                              }
                            >
                              <i className="fa fa-table" aria-hidden="true"></i>
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="card-content">
                        <div
                          className={
                            isOverAllNpsChartView
                              ? "overallNPS pb-1"
                              : "overallNPS pb-1 d-none"
                          }
                        >
                          {/* Donut chart */}
                          <DonutChart data={donutData} options={donutOptions} />
                        </div>
                        <span className="totalnpscount">{totalNps}</span>
                        <span className="totalResponseRatecount">
                          Response Rate : {responseRate.toFixed(2)} %
                        </span>
                        <div
                          className={
                            isOverAllNpsGridView
                              ? "overallNPS totalnpstable"
                              : "overallNPS totalnpstable d-none"
                          }
                        >
                          <div className="table-responsive custom-table">
                            <table className="table table-sm table-hover mb-0">
                              <thead>
                                <tr>
                                  <th className="text-center">
                                    <span className="overallNpsChartHeaders">
                                      Dr Lal Path labs
                                    </span>
                                  </th>
                                  <th className="text-center">
                                    <span className="overallNpsChartHeaders">
                                      {promotors + passives + detractors}
                                    </span>
                                  </th>
                                  <th className="text-center">
                                    <span className="overallNpsChartHeaders">
                                      100%
                                    </span>
                                  </th>
                                </tr>
                                <tr>
                                  <th>Indicator</th>
                                  <th className="text-center">Total Count</th>
                                  <th className="text-center">% Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Promoters</td>
                                  <td className="text-center">{promotors}</td>
                                  <td className="text-center">
                                    {promotorsPercentage}%
                                  </td>
                                </tr>
                                <tr>
                                  <td>Passives</td>
                                  <td className="text-center">{passives}</td>
                                  <td className="text-center">
                                    {passivesPercentage}%
                                  </td>
                                </tr>
                                <tr>
                                  <td>Detractors</td>
                                  <td className="text-center">{detractors}</td>
                                  <td className="text-center">
                                    {detractorsPercentage}%
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Project Wise NPS */}
                <div
                  className={
                    projectFilter.split(",").includes("1") ||
                    projectFilter.split(",").includes("4") ||
                    projectFilter.split(",").includes("5")
                      ? "col-12 col-md-6 col-lg-4"
                      : "col-14 col-md-8 col-lg-6"
                  }
                >
                  <div className="card">
                    <div className="card-body p-0 pb-2">
                      <div className="projectwiseNPS">
                        <div className="">
                          <table
                            className="table table-sm mb-0"
                            style={{ tableLayout: "fixed" }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "20%",
                                    textAlign: "left !important",
                                  }}
                                >
                                  Projects
                                </th>
                                <th
                                  style={{ width: "8%" }}
                                  className="text-nowrap text-end"
                                >
                                  NPS
                                </th>
                                <th
                                  style={{ width: "26%" }}
                                  className="text-nowrap text-end"
                                >
                                  Responses
                                </th>
                                <th
                                  style={{ width: "47%" }}
                                  className="text-nowrap text-end"
                                >
                                  NPS Distribution
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {projectWiseNps.map((project, index) => {
                                const totalResponses =
                                  project.PromotorsCount +
                                  project.PassivesCount +
                                  project.DetractorsCount;

                                // Calculate percentages
                                const promotorsPercentage = totalResponses
                                  ? (project.PromotorsCount / totalResponses) *
                                    100
                                  : 0;
                                const passivesPercentage = totalResponses
                                  ? (project.PassivesCount / totalResponses) *
                                    100
                                  : 0;
                                const detractorsPercentage = totalResponses
                                  ? (project.DetractorsCount / totalResponses) *
                                    100
                                  : 0;

                                return (
                                  <tr className="" key={index}>
                                    <td
                                      style={{ textAlign: "left !important" }}
                                    >
                                      {project.Project}
                                    </td>
                                    <td className="text-end">{project.Nps}</td>
                                    <td className="text-end">
                                      {project.Response}
                                    </td>
                                    <td>
                                      <span className="d-block">
                                        <div className="container">
                                          <div className="row nps-distribution-chart">
                                            <div
                                              className="col nps-chart nps-promoters"
                                              style={{
                                                width: `${promotorsPercentage}%`,
                                              }}
                                            >
                                              {/* {promotorsPercentage.toFixed(1)}% */}
                                            </div>
                                            <div
                                              className="col nps-chart nps-passives"
                                              style={{
                                                width: `${passivesPercentage}%`,
                                              }}
                                            >
                                              {/* {passivesPercentage.toFixed(1)}% */}
                                            </div>
                                            <div
                                              className="col nps-chart nps-detractor"
                                              style={{
                                                width: `${detractorsPercentage}%`,
                                              }}
                                            >
                                              {/* {detractorsPercentage.toFixed(1)}% */}
                                            </div>
                                            <div className="aggrigate-title">
                                              <table className="table table-sm mb-0 borderless">
                                                <tbody>
                                                  <tr>
                                                    <td>Promoters</td>
                                                    <td>
                                                      {project.PromotorsCount} (
                                                      {promotorsPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Passives</td>
                                                    <td>
                                                      {project.PassivesCount} (
                                                      {passivesPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Detractors</td>
                                                    <td>
                                                      {project.DetractorsCount}{" "}
                                                      (
                                                      {detractorsPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={
                    projectFilter.split(",").includes("1") ||
                    projectFilter.split(",").includes("4") ||
                    projectFilter.split(",").includes("5")
                      ? "col-12 col-md-6 col-lg-4"
                      : "d-none col-12 col-md-6 col-lg-4"
                  }
                >
                  <div className="card">
                    <div className="card-body p-0 pb-2">
                      <div className="projectwiseNPS">
                        <div className="">
                          <table
                            className="table table-sm mb-0"
                            style={{ tableLayout: "fixed" }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    width: "25%",
                                    textAlign: "left !important",
                                  }}
                                >
                                  {projectFilter.split(",").includes("1")
                                    ? "SOB"
                                    : "Location Name"}
                                </th>
                                <th
                                  style={{ width: "9%" }}
                                  className="text-end text-nowrap"
                                >
                                  NPS
                                </th>
                                <th
                                  style={{ width: "20%" }}
                                  className="text-end text-nowrap"
                                >
                                  Responses
                                </th>
                                <th
                                  style={{ width: "47%" }}
                                  className="text-nowrap text-center"
                                >
                                  NPS Distribution
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {/* {projectWiseNps.map((project, index) => { */}
                              {sobChartData.map((items, index) => {
                                const totalResponses =
                                  items.PromotersCount +
                                  items.PassivesCount +
                                  items.DetractorsCount;

                                // Calculate percentages
                                const promotersPercentage = totalResponses
                                  ? (items.PromotersCount / totalResponses) *
                                    100
                                  : 0;
                                const passivesPercentage = totalResponses
                                  ? (items.PassivesCount / totalResponses) * 100
                                  : 0;
                                const detractorsPercentage = totalResponses
                                  ? (items.DetractorsCount / totalResponses) *
                                    100
                                  : 0;
                                return (
                                  <tr className="" key={index}>
                                    <td
                                      style={{ textAlign: "left !important" }}
                                    >
                                      {items.Sob}
                                    </td>
                                    <td className="text-end">{items.Nps}</td>
                                    <td className="text-end">
                                      {items.Responses}
                                    </td>
                                    <td>
                                      <span className="d-block">
                                        <div className="container">
                                          <div className="row nps-distribution-chart">
                                            <div
                                              className="col nps-chart nps-promoters"
                                              style={{
                                                width: `${promotersPercentage}%`,
                                              }}
                                            >
                                              {/* {promotorsPercentage}% */}
                                            </div>
                                            <div
                                              className="col nps-chart nps-passives"
                                              style={{
                                                width: `${passivesPercentage.toFixed(
                                                  2
                                                )}%`,
                                              }}
                                            >
                                              {/* {passivesPercentage.toFixed(2)}% */}
                                            </div>
                                            <div
                                              className="col nps-chart nps-detractor"
                                              style={{
                                                width: `${detractorsPercentage.toFixed(
                                                  2
                                                )}%`,
                                              }}
                                            >
                                              {/* {detractorsPercentage.toFixed(2)}% */}
                                            </div>
                                            <div className="aggrigate-title">
                                              <table className="table table-sm mb-0 borderless">
                                                <tbody>
                                                  <tr>
                                                    <td>Promoters</td>
                                                    <td>
                                                      {items.PromotersCount} (
                                                      {promotersPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Passives</td>
                                                    <td>
                                                      {items.PassivesCount} (
                                                      {passivesPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Detractors</td>
                                                    <td>
                                                      {items.DetractorsCount} (
                                                      {detractorsPercentage.toFixed(
                                                        2
                                                      )}
                                                      %)
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        </div>
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Engagement Trends */}
                <div className="col-12 col-md-6 col-lg-6">
                  <EngagementTrends
                    data={engagementTrends}
                    pFilter={projectFilter}
                    from={fromDate}
                    to={toDate}
                    qFilter={quickFilter}
                  />
                </div>

                {/* Related Trends */}
                <div className="col-12 col-md-6 col-lg-6">
                  <div className="card">
                    <div className="card-body p-1">
                      <div className="card-title d-flex align-items-center">
                        <h3>
                          Trends{" "}
                          <span>
                            - (Total Responses :{" "}
                            {promotors + passives + detractors})
                          </span>
                        </h3>
                        <div className="card-option d-flex ms-auto">
                          <ButtonGroup className="view-type" size="sm">
                            <Button
                              onClick={handleNpsTrendsChartView}
                              variant="outline-secondary"
                              className={
                                isNpsTrendsChartView
                                  ? "active px-2 py-1"
                                  : "px-2 py-1"
                              }
                            >
                              <i
                                className="fa fa-bar-chart"
                                aria-hidden="true"
                              ></i>
                            </Button>
                            <Button
                              onClick={handleNpsTrendsBarView}
                              variant="outline-secondary"
                              className={
                                isNpsTrendsBarView
                                  ? "active px-2 py-1"
                                  : "px-2 py-1"
                              }
                            >
                              <i className="fa fa-bars" aria-hidden="true"></i>
                            </Button>
                          </ButtonGroup>
                        </div>
                      </div>
                      <div className="card-content">
                        <div className="trends-chart">
                          {isNpsTrendsChartView ? (
                            <CombinedChart data={npsTrendsChart} />
                          ) : (
                            <StackedPercentageBarChart
                              responseData={npsTrendsChart}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Customer Experience */}
                <div className="col-12 col-md-12 col-lg-7 mb-2">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="card-title d-flex align-items-center">
                        <h3>Customer Experience</h3>
                        <span className="btnCustomerExperienceViewDetail">
                          <a
                            className={
                              projectFilter != ""
                                ? "link-btn"
                                : "disabled link-btn"
                            }
                            href="/textWordCloud"
                          >
                            View Details
                          </a>
                        </span>
                      </div>
                      <div className="card-content">
                        <div className="row g-2">
                            <CustomerExperienceSearch/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Journey Metrics */}
                <div className="col-12 col-md-12 col-lg-5 mb-2">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="card-title d-flex align-items-center">
                        <h3 className="pb-2">Journey Metrics - (Responses)</h3>
                        <span className="btnJourneyMetricsViewDetail">
                          <a
                            className={
                              projectFilter != ""
                                ? "link-btn"
                                : "disabled link-btn"
                            }
                            href="/journeyMetrics"
                          >
                            View Details
                          </a>
                        </span>
                      </div>
                      <div className="card-content">
                        <div className="row g-2">
                          <div className="col-md-6 col-12 col-sm-12 col-lg-6 col-xl-6">
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: "178px" }}
                            >
                              <ResponseThrough data={journeyMetrics} />
                            </div>
                          </div>
                          <div className="col-md-6 col-12 col-sm-12 col-lg-6 col-xl-6">
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: "178px" }}
                            >
                              <ResponseType data={journeyMetrics} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        </section>
      </div>
    </div>
  );
}

export default Dashboard;
//end
